import Joi from 'joi';

import { IdentityDocumentTypeEnum } from '../../../../shared/enums/identity-document-type.enum';

/**
 * Schema for driver validation.
 * @returns - A Joi object schema object.
 */

export const updateTenantDriverSchema = () =>
	Joi.object({
		id: Joi.number().required().messages({
			'any.required': 'validations|driver-id|required',
			'number.base': 'validations|driver-id|must-be-number',
		}),

		identityDocumentType: Joi.string()
			.valid(...Object.values(IdentityDocumentTypeEnum))
			.allow(null)
			.messages({
				'any.only': 'validations|driver-identity-document-type|invalid-value',
			}),

		identityDocumentNumber: Joi.string().allow(null).messages({
			'string.base':
				'validations|driver-identity-document-number|must-be-string',
		}),

		identityDocumentIssuedByCountryId: Joi.number().allow(null).messages({
			'number.base':
				'validations|driver-identity-document-issued-by-country-id|must-be-number',
		}),

		identityDocumentIssueDate: Joi.date().allow(null).messages({
			'date.base':
				'validations|identity-document-issue-date|must-be-a-valid-date',
		}),

		identityDocumentExpiryDate: Joi.date()
			.greater(Joi.ref('identityDocumentIssueDate'))
			.allow(null)
			.messages({
				'date.base':
					'validations|identity-document-expiry-date|must-be-a-valid-date',
				'date.greater':
					'validations|identity-document-expiry-date|cannot-be-before-issue-date',
			}),

		drivingLicenses: Joi.array()
			.items(
				Joi.object({
					id: Joi.number().allow(null).messages({
						'number.base': 'validations|driver-license-id|must-be-number',
					}),
					number: Joi.string().allow(null).messages({
						'string.base': 'validations|driver-license-number|must-be-string',
					}),
					category: Joi.string().allow(null).messages({
						'string.base': 'validations|driver-license-category|must-be-string',
					}),
					issueDate: Joi.date().allow(null).messages({
						'date.base':
							'validations|driving-license-issue-date|must-be-a-valid-date',
					}),
					expiryDate: Joi.date()
						.greater(Joi.ref('issueDate'))
						.allow(null)
						.messages({
							'date.base':
								'validations|driving-license-expiry-date|must-be-a-valid-date',
							'date.greater':
								'validations|driving-license-expiry-date|cannot-be-before-issue-date',
						}),
					issuedByCountryId: Joi.number().allow(null).messages({
						'number.base':
							'validations|driver-license-issued-by-country-id|must-be-number',
					}),
				}),
			)
			.allow(null),
	})
		// Ignore extra fields
		.unknown();
